import { AuthGuard } from '../auth/AuthGuard';
import { SurveyQuestionsScreen } from './SurveyQuestionsScreen';

export const SurveyQuestions = ({ authPath, surveyQuestionsPath }) => (
  <AuthGuard authPath={authPath}>
    <SurveyQuestionsScreen surveyQuestionsPath={surveyQuestionsPath} />
  </AuthGuard>
);
